<template>
    <div>
        <card-header title="Enrollments" icon="fa-users"></card-header>

<!--        <card-toolbar>-->
<!--            <button @click="$openCard('conf-communicate', {confId: conference.id, type: commType}, card)"><i class="far fa-comment"></i>Communicate</button>-->
<!--            <button @click="exportRegistrations()"><i class="far fa-file-excel"></i>Export</button>-->
<!--        </card-toolbar>-->

        <card-body>
            <card-list>
                <subheader-list-item title="Enrollments" icon="fa-users" />
                <enrollment-tile
                    :card="card"
                    :enrollment="enroll"
                    :course="course"
                    v-for="enroll in enrollments"
                    @click="$openCard('enrollment', {enrollId: enroll.id, courseId: props.courseId}, card)"
                    :active="(child && child.definition.component === 'enrollment' && enroll.id === parseInt(child.props.enrollId))"
                />
            </card-list>
            <infinite-loading @infinite="loadEnrollments">
                <div slot="no-more"></div>
                <div slot="no-results">No Records Found</div>
            </infinite-loading>
        </card-body>

        <card-footer>
            Showing <strong>{{ enrollments.length | numeral('0,0') }}</strong> of <strong>{{ paging.total | numeral('0,0') }}</strong> {{viewType}} Enrollments
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http, apiUrl} from "@/http_client";
    import ConferenceTile from "../../../components/tiles/ConferenceTile";
    import RegistrationTile from "../../../components/tiles/RegistrationTile";
    import Login from "../../../views/Login";
    import CardToolbar from "../../../TIER/components/CardToolbar.vue";
    import EnrollmentTile from "../../../components/tiles/EnrollmentTile.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {EnrollmentTile, CardToolbar, RegistrationTile, ConferenceTile, CardFooter, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                course: null,
                enrollments: [],
                paging: {
                    total: 0,
                    start: 0,
                    count: 0
                },
                apiUrl: apiUrl,
            };
        },
        computed: {
            viewType() {
                switch (this.props.type) {
                    case 'all':
                        return 'Total'
                    case 'complete':
                        return 'Complete'
                    case 'progress':
                        return 'In Progress'
                    case 'missing':
                        return 'Missing Application(s)'
                }
            }
        },
        methods: {
            load: function () {
                http.get('courses/new/' + this.props.courseId).then(response => {
                    this.course = response.data;
                });
            },
            loadEnrollments: function ($state) {
                let q = (this.props.query) ? this.props.query : 'null';

                http.get(`/courses/new/${this.props.courseId}/enrollments/${this.props.type}/${this.paging.start}/500`, {force: true}).then(response => {
                    this.enrollments.push(...response.data.enrollments);
                    this.paging.total = response.data.total;
                    this.paging.count = response.data.count;
                    this.paging.start += response.data.enrollments.length;

                    if ($state) $state.loaded();

                    if ($state && response.data.total <= this.enrollments.length) {
                        $state.complete();
                    }

                    this.$emit('loading', false);
                });
            },
            loadAgain: function () {
                this.enrollments = [];
                this.paging = {
                    total: 0,
                    start: 0,
                    count: 0
                };

                this.loadEnrollments();
            },
            exportRegistrations: function () {
                // http.get(`${this.apiUrl}conferences/${this.props.confId}/registrations/${this.props.type}/export`)
                //     .then(response => {
                //     const url = window.URL.createObjectURL(new Blob([response.data]));
                //     const link = document.createElement('a');
                //     link.href = url;
                //     link.setAttribute('download', 'registrations.csv');
                //     document.body.appendChild(link);
                //     link.click();
                // })
                // .catch(error => {
                //     console.log(error);
                //     // if error is 404
                //     if (error.response.status === 404) {
                //         window.alert('No registrations to export');
                //         return;
                //     } else {
                //         window.alert('Error exporting registrations');
                //         return;
                //     }
                // });
            },
            reload: function () {
                console.log('Reloading registrations');
                this.loadAgain();
            }
        },
        watch: {
            'props.type': function () {
                this.enrollments = [];
                this.paging = {
                    total: 0,
                    start: 0,
                    count: 0
                };
                this.loadAgain();
            }
        },
        mounted: function () {
            this.load();
        }
    };
</script>
